export class Defaults {
    public static readonly EmptyString = '';
}
